<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="countryIndetifiersAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <label
              *ngIf="countryIndetifiersAddEditForm.get('region')?.value"
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <div class="services-form">
              <input
                [style.background]="isReadOnly ? '#f9f9f9' : ''"
                formControlName="country"
                type="text"
                maxlength="30"
                [readOnly]="isReadOnly"
                placeholder="Country *"
              />
              <label>Country</label>
              <div
                *ngIf="submitted || countryIndetifiersAddEditForm.controls['country']?.touched"
                class="input-error"
              >
                <div *ngIf="countryIndetifiersAddEditForm.controls['country']?.invalid">
                  Country is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="countryIndetifiersAddEditForm.get('region')?.value"
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionList"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [searchFn]="commonInputSearch"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="region.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (countryIndetifiersAddEditForm.controls['region']?.touched &&
                  countryIndetifiersAddEditForm.controls['region']?.invalid) ||
                countryIndetifiersAddEditForm.controls['region'].value?.name ===
                  '-- Select Region --' ||
                (submitted && !countryIndetifiersAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
